import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CookieHelper } from '../../common/cookie-helper';
import { AccountSummaryModule } from '../accountsummary/account-summary.module';
import { AcctactvtyModule } from '../acctactvty/acctactvty.module';
import { FlyoutFeedModule } from '../flyout-feed/flyout-feed.module';
import { FlyoutTodayModule } from '../flyout-today/flyout-today.module';
// This Module's Components
import { FlyoutTrackerModule } from '../flyout-tracker/flyout-tracker.module';
import { FlyoutLoggedinComponent } from './flyout-loggedin.component';

@NgModule({ declarations: [FlyoutLoggedinComponent],
    exports: [FlyoutLoggedinComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        AccountSummaryModule,
        FlyoutTodayModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AcctactvtyModule,
        FlyoutFeedModule,
        FlyoutTrackerModule], providers: [CookieHelper, provideHttpClient(withInterceptorsFromDi())] })
export class FlyoutLoggedinModule {}
